import { isString, SBaseDisplay, SDate } from '@summit/core';

import { WorkersCompCode, WorkersCompCodeMapping } from '@app/models/reports2/insurance/workers-comp-code.enum';
import { SummitFormattedText } from '@summit/models';
import { EboObjectTimeLine } from '../base-classes/ebo-object-time-line';
import { RouteStatus, RouteStatusMapping } from './route-status.enum';
import { RouteType, RouteTypeMapping } from './route-type.enum';

export class RouteTimeline extends EboObjectTimeLine implements SBaseDisplay {
  routeID: string;
  expectedMiles: number;
  status: RouteStatus; // enum
  type: RouteType; // enum
  workersCompCode: WorkersCompCode; // enum
  perDiem: boolean;
  perDiemExcludeSolo: boolean;
  perDiemOutBoundOnly: boolean;
  perDiemDays: number;
  exclusivelyLegWage: boolean;

  constructor(jsonData?: Partial<RouteTimeline>) {
    super(jsonData);
    if (!this.status) {
      this.status = RouteStatus.Active;
    }
    if (isString(this.status)) this.status = parseInt(this.status, 10);
    if (!this.type) {
      this.type = RouteType.SoloDedicated;
    }
    if (isString(this.type)) this.type = parseInt(this.type, 10);
    this.exclusivelyLegWage ??= false;
    this.effectiveDate ??= SDate.getNormalized();
    this.perDiem ??= false;
    this.perDiemExcludeSolo ??= false;
    this.workersCompCode ??= WorkersCompCode.Unknown;
  }

  toShortString(): string {
    return `${this.effectiveDate ? this.effectiveDate.format('M/D/YY') : 'Unknown'} - ${
      RouteStatusMapping[this.status]
    }`;
  }

  isTeam(): boolean {
    return [RouteType.TeamUnassigned, RouteType.TeamSpare, RouteType.TeamDedicated].includes(this.type);
  }

  private _typeSummary: SummitFormattedText;
  get typeSummary(): SummitFormattedText {
    if (this._typeSummary === undefined) {
      this._typeSummary = new SummitFormattedText();
      this._typeSummary.AddLine(RouteTypeMapping[this.type], ['flex', 'grow', 'justify-center', 'text-bold']);
      if (this.workersCompCode) {
        this._typeSummary.AddKeyValues(`WC Class`, WorkersCompCodeMapping[this.workersCompCode]);
      }
    }
    return this._typeSummary;
  }

  private _perDiemSummary: SummitFormattedText;
  get perDiemSummary(): SummitFormattedText {
    if (this._perDiemSummary === undefined) {
      this._perDiemSummary = new SummitFormattedText();
      if (this.perDiem) {
        this._perDiemSummary.AddKeyValues('Per Diem', 'Yes');
        if (this.perDiemExcludeSolo) {
          this._perDiemSummary.AddLine('Excludes Solo');
        }
        if (this.perDiemOutBoundOnly) this._perDiemSummary.AddKeyValues('Out Bound Only', 'Yes');
        if (this.perDiemDays) this._perDiemSummary.AddKeyValues(`Weekly Limit`, `${this.perDiemDays} days`);
      } else {
        this._perDiemSummary.AddKeyValues('Per Diem', 'No');
      }
    }
    return this._perDiemSummary;
  }

  clearCache(): void {
    this._typeSummary = undefined;
    this._perDiemSummary = undefined;
  }
}
